var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 2.4V0L1.875 3L5 6V3.6C7.06875 3.6 8.75 5.214 8.75 7.2C8.75 9.186 7.06875 10.8 5 10.8C2.93125 10.8 1.25 9.186 1.25 7.2H0C0 9.852 2.2375 12 5 12C7.7625 12 10 9.852 10 7.2C10 4.548 7.7625 2.4 5 2.4Z","fill":"currentColor"}));
}

Reset.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 10 12","fill":"none"};

module.exports = Reset;

Reset.default = Reset;
